import React, { useRef, useState } from 'react';
import { ChevronLeft, Xmark } from '@gravity-ui/icons';
import { Button, Icon, Popup, Sheet } from '@gravity-ui/uikit';
import { format } from 'date-fns';

import type { PatientEstimate } from 'store/types/common';

import { SHOW_HISTORY } from '../../constants';

import styles from './styles.module.scss';

interface ClientGoalHistoryProps {
	history: PatientEstimate[];
}

export const ClientGoalHistorySheet = ({ history }: ClientGoalHistoryProps) => {
	const [open, setOpen] = useState(false);

	// Группируем patientEstimates по датам и выбираем последний по ID для каждой даты
	const getUniqueEstimatesByDate = () => {
		if (!history) return [];

		const estimatesByDate = history.reduce(
			(acc, est) => {
				const dateKey = est.date || '';
				if (!acc[dateKey]) {
					acc[dateKey] = [];
				}
				acc[dateKey].push(est);
				return acc;
			},
			{} as Record<string, PatientEstimate[]>,
		);

		// Для каждой даты выбираем patientEstimate с максимальным ID
		const uniqueEstimates = Object.values(estimatesByDate).map((estimates) =>
			estimates.reduce((latest, current) => {
				return (current.id || 0) > (latest.id || 0) ? current : latest;
			}),
		);

		// Сортируем по дате
		return uniqueEstimates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
	};

	const uniqueHistory = getUniqueEstimatesByDate();

	return (
		<>
			<Button
				onClick={() => setOpen((prevOpen) => !prevOpen)}
				className={styles.history__button}
				view="normal"
				size="s"
			>
				{SHOW_HISTORY}
			</Button>

			<Sheet className={styles.history__popup} visible={open} onClose={() => setOpen(false)}>
				<div className={styles.history__popup__header}>
					<Button onClick={() => setOpen((prevOpen) => !prevOpen)} view="normal-contrast" size="s">
						<Icon data={ChevronLeft} size={20} />
					</Button>
					<h3>История целей</h3>
				</div>
				<div className={styles.history__popup__content}>
					{uniqueHistory.map((item, index) => (
						<div className={styles.history__popup__content__item} key={item.id || index}>
							<span className={styles.history__popup__content__date}>
								{format(new Date(item.date), 'dd.MM.yyyy')}
							</span>
							<span className={styles.history__popup__content__goal}>{item.goal}</span>
						</div>
					))}
				</div>
			</Sheet>
		</>
	);
};
